export default "__VITE_ASSET__Bazhs$oe__"